import { useState } from "react";
import Download from "./components/scripts/download_xml";
import Revisor from "./components/scripts/revisor";
import { Container } from "./styles";

export default function Tools({ toolToOpen, onClose }) {
  const [status, setStatus] = useState(toolToOpen);

  const handleClose = () => {
    onClose();
    document.getElementById("tools").style.display = "none";
  };

  const renderTool = () => {
    switch (status) {
      case "download_xml":
        return (
          <Download
            status={status}
            setStatus={setStatus}
            handleClose={handleClose}
          />
        );
      case "revisor":
        return (
          <Revisor
            status={status}
            setStatus={setStatus}
            handleClose={handleClose}
          />
        );
      default:
        return null;
    }
  };

  return <Container id="tools">{renderTool()}</Container>;
}
